<template>
  <window ref="window" size="full" title="">
    <editable
      slot-scope="window"
      :show-toggle-button="false"
      default-state="edit"
    >
      <template slot-scope="editable">
        <div class="text-center">
          <img src="/img/job/suva.svg" width="100px" height="auto" />
        </div>

        <div v-html="window.data"></div>

        <div class="mt-lg mb-lg">
          <editable-check
            name="read"
            label="Ich habe die Sicherheitsregeln gelesen und befolge diese mit bestem Gewissen"
            :icon-src="icon"
          ></editable-check>
        </div>

        <div class="buttons mb-3">
          <button class="btn btn-secondary" @click="window.hide(false)">
            Abbrechen
          </button>

          <button
            class="btn btn-next"
            @click="window.hide(true)"
            :disabled="!editable.data.read"
          >
            Montage beginnen
          </button>
        </div>
      </template>
    </editable>
  </window>
</template>

<script>
export default {
  provide: {
    windowId: "jobSuva",
  },
};
</script>